import { useContext } from 'react';
import { AuthContext } from 'react-oauth2-code-pkce';
import { useLocation } from 'react-router-dom';
import type { OAuthState } from '../services/auth/types';

/**
 * Logs the user in with a CSRF token and redirect path.
 */
const useLogIn = (): () => void => {
  const { pathname } = useLocation();
  const { logIn } = useContext(AuthContext);

  return () => {
    const state: OAuthState = {
      csrf: crypto.randomUUID(),
      redirectPath: pathname,
    };

    logIn(JSON.stringify(state));
  };
};

export default useLogIn;
